import { OrderDetail } from "../models/csos/orderDetails";

export const buildModifiedOrderLines = (orderLines: any[]): OrderDetail[] => {
  const odArray: OrderDetail[] = [];
  for (let i = 0; i < orderLines.length; i++) {
    if (orderLines[i].orderQuantity !== orderLines[i].oldOrderQuantity) {
      odArray.push({
        availableOrdQty: orderLines[i].orderQuantity,
        availableOrdQtyOld: orderLines[i].oldOrderQuantity,
        cin: orderLines[i].cin,
        itemId: orderLines[i].itemId,
        originalOrdQty: orderLines[i].originalQuantity,
        sequenceNumber: orderLines[i].sequence,
      });
    }
  }
  return odArray;
};
